<template>
  <image-container-card
    v-bind="$attrs"
    v-on="$listeners"
    :image="item.thumbnail || item.image"
  >
    <align justify="space-between">
      <div class="platform-text">
        <span>{{ item.platform }}</span><span v-if="item.seller"> - {{ item.seller }}</span>
      </div>
    </align>

    <div class="item-text">{{ item.title }}</div>

    <align direction="flex-end" justify="space-between">
      <align small-gap>
        <card-stat-item
          :card="item"
          stat="price"
        />

        <verified-icon v-if="verified" />
      </align>


      <div class="extra-info">
        <span>{{ item.listingType }}</span>
        <span>{{ $filters.date(item.date) }}</span>
      </div>
    </align>
  </image-container-card>
</template>

<script>
import Align from './Align';
import CardStatItem from './CardStatItem';
import ImageContainerCard from './ImageContainerCard';
import VerifiedIcon from './VerifiedIcon';

export default {
  components: {
    Align,
    CardStatItem,
    ImageContainerCard,
    VerifiedIcon,
  },

  props: {
    item: Object,
    verified: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.item-text {
  margin-bottom: $gp * .5;
  font-weight: bold;
  font-size: 16px;

  @media($small-up) {
    height: 75px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.extra-info {
  display: flex;
  flex-direction: column;
  text-align: right;
  padding-bottom: 5px;

  span {
    font-size: 12px;
    font-weight: bold;
  }
}

.platform-text {
  font-size: 12px;
  text-transform: uppercase;
  opacity: 0.5;
  letter-spacing: 1px;
  height: 15px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
